import { desktopRelease } from "@/lib/desktop-release";
import DownloadDialogView from "./DownloadDialogView";

export default function DownloadDialog() {
  return (
    <DownloadDialogView
      version={desktopRelease.version}
      downloads={[
        { label: "Mac — Apple Silicon", detail: "For Macs with an M-series chip", platform: "mac", href: desktopRelease.arm64 },
        { label: "Mac — Intel", detail: "For Intel-based Macs", platform: "mac", href: desktopRelease.x64 },
        { label: "Windows", detail: `64-bit installer, version ${desktopRelease.windowsVersion}`, platform: "windows", href: desktopRelease.windows },
      ]}
      // Fixed, not an env var: a stale NEXT_PUBLIC_STONE_RECORDER_URL on Vercel
      // kept sending this button to the retired stone-id.sebweb.studio address.
      betaUrl="https://app.writeinstone.com/record/"
    />
  );
}
